import { useState } from 'react';
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';

export default function CounterUp({ start, end }) {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <>   
    <ScrollTrigger onEnter={()=> setCounterOn(true)} onExit={()=> setCounterOn(false)}>
      {
        counterOn && <CountUp
        start={start}
        end={end}
        duration={1}
        separator=" "
        // decimals={3}
        // decimal="," 
        />  
      }   
      </ScrollTrigger>   
    </>
  )}